<template>
  <modal
    :title="setModel > 0 ? 'Update Customer User' : 'Add Customer User'"
    @close="$emit('close')"
    size="xl"
  >
    <template #content>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
      >
        <div class="row">
          <div class="col-4">
            <formGroup
              :title="'Name'"
              v-model="model.Name"
              :errors="errors"
              :rules="{ required: true, max: 100 }"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Gender'"
              v-model="model.Gender"
              :as="'select'"
              :errors="errors"
              :rules="{ required: true, max: 100 }"
              @keydown.enter="save"
            >
              <template #input>
                <option value="F">Female</option>
                <option value="M">Male</option>
              </template>
            </formGroup>
            <formGroup
              :title="'Email'"
              v-model="model.Email"
              :errors="errors"
              :rules="{ required: true, max: 100, email: true }"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Phone'"
              maska="0### ### ####"
              v-model="model.Phone"
              :errors="errors"
              :rules="{ required: true, min: 13 }"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Password'"
              type="password"
              v-model="model.Password"
              :errors="errors"
              :rules="{ max: 20 }"
              @keydown.enter="save"
            ></formGroup>
            <div class="birthDate">
              <formGroup
                :title="'BirthDate'"
                :type="'date'"
                v-model="model.BirthDate"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
              <!-- <span>{{$burcHesaplama(model.BirthDate)}}</span> -->
            </div>
            <formGroup
              :title="'Position'"
              v-model="model.Position"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroupTag
              :title="'WhiteIp'"
              v-model="model.ips"
              :errors="errors"
              :rules="{
                regex: /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)(\.(?!$)|$)){4}$/,
              }"
              :checkDisabled="true"
              :disabled="!isWhiteIp"
              @keydown.enter="$refs.form.validateField('Güvenli Ipler')"
            >
              <template #checkDisabled>
                <formGroup
                  as="checkbox"
                  v-model="isWhiteIp"
                  :errors="errors"
                  :rules="{ max: 4000 }"
                ></formGroup>
              </template>
            </formGroupTag>
            <formGroup
              :title="'MaxReturnDayOnSaleDate'"
              type="number"
              v-model="model.MaxReturnDayOnSaleDate"
              :disabled="!model.ChangeSaleDate"
              :checkDisabled="true"
              :errors="errors"
              @keydown.enter="save"
            >
              <template #checkDisabled>
                <formGroup
                  as="checkbox"
                  v-model="model.ChangeSaleDate"
                  :errors="errors"
                  :rules="{ max: 4000 }"
                  @keydown.enter="save"
                ></formGroup>
              </template>
            </formGroup>
          </div>
          <div class="col-4 border-left">
            <div class="card colapse m-b-10" style="border-radius: 0;">
              <div class="card-header">
                <formGroup
                  :title="'Rezervasyonları Görebilsin'"
                  as="checkbox"
                  v-model="model.ShowReservations"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div v-if="model.ShowReservations" class="p-10 p-l-20 border-top">
                <formGroup
                  :title="'Otel yazılımına kaydedebilsin'"
                  as="checkbox"
                  v-model="model.SoftwareSideConfirm"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Acentaya confirm gönderebilsin'"
                  as="checkbox"
                  v-model="model.AgencyConfirm"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Not confirm gönderebilsin'"
                  as="checkbox"
                  v-model="model.NotConfirm"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Toplu işlem yapabilsin'"
                  :as="'checkbox'"
                  v-model="model.MassConfirm"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Sabit fiyat girebilsin'"
                  as="checkbox"
                  v-model="model.ManuelPrice"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Rezervasyonları onaylayabilsin'"
                  as="checkbox"
                  v-model="model.Approver"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Rezervasyonları onaydan geri çekebilsin'"
                  as="checkbox"
                  v-model="model.DrawbackApprove"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Stoplu tarihe rezervasyon girebilsin'"
                  as="checkbox"
                  v-model="model.Unstopable"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Re Confirm Software Side'"
                  :as="'checkbox'"
                  v-model="model.ReConfirmSoftwareSide"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Update Old Reservation'"
                  :as="'checkbox'"
                  v-model="model.UpdateOldReservation"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Rezervasyonu tekrar gösterme yapabilsin'"
                  :as="'checkbox'"
                  v-model="model.DontShowAgain"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
            </div>
            <div class="card colapse m-b-10" style="border-radius: 0;">
              <h4 class="card-header" style="padding-top:11px; padding-bottom:11px;">
                Bildirimleri Alsın
                <!-- <formGroup
                  :title="'Bildirimleri Alsın'"
                  as="checkbox"
                  v-model="sendNotification"
                  @keydown.enter="save"
                ></formGroup> -->
              </h4>
              <div class="p-10 p-l-20 border-top">
                <formGroup
                  :title="'Notify Provider Access Problems'"
                  as="checkbox"
                  v-model="model.NotifyProviderAccessProblems"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Notify PMS Access Problems'"
                  as="checkbox"
                  v-model="model.NotifyPMSAccessProblems"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Notify Mail Convert Problems'"
                  as="checkbox"
                  v-model="model.NotifyMailConvertProblems"
                  @keydown.enter="save"
                ></formGroup>
                <formGroup
                  :title="'Notify Birthday Messages'"
                  as="checkbox"
                  v-model="model.NotifyBirthdayMessages"
                  @keydown.enter="save"
                ></formGroup>
              </div>
            </div>
          </div>
          <div class="col-4 border-left">
            <div class="card colapse m-b-10" style="border-radius: 0;">
              <h4 class="card-header" style="padding-top:11px; padding-bottom:11px;">
                Rapor Yetkileri
              </h4>
              <div class="p-10 p-l-20 border-top">
            <formGroup
              :title="'Saved Reservation Report'"
              :as="'checkbox'"
              v-model="model.SavedReservationReport"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Person Performance Report'"
              :as="'checkbox'"
              v-model="model.PersonPerformanceReport"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Approve Reservation Report'"
              :as="'checkbox'"
              v-model="model.ApproveReservationReport"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
              </div>
            </div>
            <div class="card colapse m-b-10" style="border-radius: 0;">
              <h4 class="card-header" style="padding-top:11px; padding-bottom:11px;">
                Diğer Yetkiler
              </h4>
              <div class="p-10 p-l-20 border-top">
            <formGroup
              :title="'Accountant'"
              :as="'checkbox'"
              v-model="model.Accountant"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Send SMS'"
              :as="'checkbox'"
              v-model="model.SendSMS"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Show Providers'"
              :as="'checkbox'"
              v-model="model.ShowProviders"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Show Daily Enter Exit'"
              :as="'checkbox'"
              v-model="model.ShowDailyEnterExit"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Show Mailbox'"
              :as="'checkbox'"
              v-model="model.ShowMailbox"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Is Customer Admin'"
              :as="'checkbox'"
              v-model="model.IsCustomerAdmin"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Call Center'"
              :as="'checkbox'"
              v-model="model.CallCenter"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Matchs'"
              :as="'checkbox'"
              v-model="model.Matchs"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Show Old Reservations'"
              :as="'checkbox'"
              v-model="model.ShowOldReservations"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Show Virtual Forecast'"
              :as="'checkbox'"
              v-model="model.ShowVirtualForecast"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Show Reservation Report'"
              :as="'checkbox'"
              v-model="model.ShowReservationReport"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <formGroup
              :title="'Show Fly Stats'"
              :as="'checkbox'"
              v-model="model.ShowFlyStats"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="process"
        :process="process"
        >{{ setModel > 0 ? "Update Customer User" : "Add Customer User" }}</Btn
      >
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    CustomerId: Number,
  },
  data() {
    return {
      addSoftwareOpen: false,
      model: {
        CustomerId: this.CustomerId,
        Name: null,
        Gender: "F",
        Email: null,
        Password: null,
        Phone: null,
        IsCustomerAdmin: false,
        BirthDate: null,
        SendSMS: true,
        ManuelPrice: true,
        SoftwareSideConfirm: true,
        AgencyConfirm: true,
        NotConfirm: true,
        MassConfirm: false,
        Accountant: false,
        ShowProviders: false,
        ChangeSaleDate: false,
        MaxReturnDayOnSaleDate: null,
        ReConfirmSoftwareSide: false,
        ShowMailbox: false,
        UpdateOldReservation: false,
        Approver: false,
        Unstopable: false,
        CallCenter: false,
        ips: [],
        Matchs: false,

        ShowReservations: true,
        ShowOldReservations: true,
        ShowVirtualForecast: true,
        ShowReservationReport: true,
        ShowFlyStats: true,
        Position: "",
        ShowDailyEnterExit:true,

        NotifyProviderAccessProblems:true,
        NotifyPMSAccessProblems:true,
        NotifyMailConvertProblems:true,
        NotifyBirthdayMessages:true,

        DrawbackApprove:false,

        DontShowAgain:true,

        SavedReservationReport:false, 
        PersonPerformanceReport:false, 
        ApproveReservationReport:false
      },
      isWhiteIp: false,
      process: false,
    };
  },
  created() {},
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          let model = { ...this.model };
          model.Password == (model.Password == "" ? null : model.Password);
          model.BirthDate == (model.BirthDate == "" ? null : model.BirthDate);
          model.Phone = this.model.Phone.replaceAll(" ", "").slice(1, 13);
          let whiteIPS = null;
          if (this.isWhiteIp && this.model.ips.length > 0) {
            whiteIPS = "";
            this.model.ips.forEach((element) => {
              whiteIPS += "," + element;
            });
            whiteIPS = whiteIPS.replace(",", "");
          }
          this.$appAxiosAdmin
            .post(`Users/Customers/Add`, {
              ...this.model,
              Phone: this.model.Phone.replaceAll(" ", "").slice(1, 13),
              WhiteIPS: whiteIPS,
            })
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer user has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit("add", response.data);
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.birthDate {
  position: relative;
}
.birthDate > span {
  position: absolute;
  right: 50px;
  top: 50%;
  line-height: 0;
  font-weight: 400;
}
</style>
